<template>
  <div class="card mgt-20px">
    <header class="header-card" >
      <p>{{ $t('addEditRegroupementProduit.informationProduits.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-4">
          <marche
            :detail="detail"
            :produit="regroupementProduit"
            :disabled="!regroupementProduit.produits.length">
          </marche>
        </div>
        <div class="column is-4">
          <regle-facturation-detail
            v-if="detail"
            :produit="regroupementProduit">
          </regle-facturation-detail>
          <regle-facturation
            v-else
            :produit="regroupementProduit"
            :disabled="!regroupementProduit.produits.length">
          </regle-facturation>
        </div>
        <div class="column is-4">
          <assistant
            :detail="detail"
            :produit="regroupementProduit"
            :disabled="!regroupementProduit.produits.length"
          />
        </div>
        <div class="column is-4">
          <select-compte-analytique
            v-if="!detail"
            :produit="regroupementProduit"
            :disabled="!regroupementProduit.produits.length"
          />
          <detail-compte-analytique
            v-else
            :produit="regroupementProduit"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import regleFacturation from '@/components/catalogue/produitGeneralPresse/edition/regleFacturation';
import regleFacturationDetail from '@/components/catalogue/produitGeneralPresse/detail/regleFacturation';
import marche from '@/components/catalogue/produitGeneralPresse/edition/marche';
import assistant from '@/components/catalogue/produitGeneralPresse/assistant';
import selectCompteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/selectCompteAnalytique';
import detailCompteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/detailCompteAnalytique';

export default {
  props: {
    regroupementProduit: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
  },
  components: {
    regleFacturation,
    regleFacturationDetail,
    marche,
    assistant,
    selectCompteAnalytique,
    detailCompteAnalytique,
  },
};
</script>
